// Goals and KPIs (OGSM): the organisation plan (one-pager) and the KPI page.
// In the app shell (OrgShell). The Plan tabs of units and collabs are routed
// by their own areas (workforce, collab) and embed <OgsmOnePager>; a collab's
// plan page for editing and printing (/org/collabs/:id/plan/edit) is in
// areas/collab/routes.tsx.
import { extra, page, type AreaRoute } from "../../routes/types";

export const routes: AreaRoute[] = [
  extra("/org/ogsm", page(() => import("./pages/OrgOgsmPage"), "OrgOgsmPage")),
  extra("/org/kpis/:kpiId", page(() => import("./pages/KpiPage"), "KpiPage")),
];
